import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as customPricingService from '@features/settings/services/customPricingService';

// Get all custom pricings (Admin)
export const useCustomPricingsQuery = (params = {}) => {
  return useQuery({
    queryKey: ["customPricings", params],
    queryFn: () => customPricingService.getAllCustomPricings(params),
    keepPreviousData: true,
  });
};

// Get user's custom pricings
export const useMyCustomPricingsQuery = (params = {}) => {
  return useQuery({
    queryKey: ["myCustomPricings", params],
    queryFn: () => customPricingService.getMyCustomPricings(params),
    keepPreviousData: true,
  });
};

// Get custom pricing by ID
export const useCustomPricingQuery = (id) => {
  return useQuery({
    queryKey: ["customPricing", id],
    queryFn: () => customPricingService.getCustomPricingById(id),
    enabled: !!id,
  });
};

// Create custom pricing
export const useCreateCustomPricing = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: customPricingService.createCustomPricing,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customPricings"] });
      queryClient.invalidateQueries({ queryKey: ["myCustomPricings"] });
    },
    onError: (error) => {
      console.error("Error creating custom pricing:", error);
    },
  });
};

// Update custom pricing
export const useUpdateCustomPricing = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) =>
      customPricingService.updateCustomPricing(id, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["customPricings"] });
      queryClient.invalidateQueries({ queryKey: ["myCustomPricings"] });
      queryClient.invalidateQueries({
        queryKey: ["customPricing", variables.id],
      });
    },
    onError: (error) => {
      console.error("Error updating custom pricing:", error);
    },
  });
};

// Delete custom pricing
export const useDeleteCustomPricing = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: customPricingService.deleteCustomPricing,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customPricings"] });
      queryClient.invalidateQueries({ queryKey: ["myCustomPricings"] });
    },
    onError: (error) => {
      console.error("Error deleting custom pricing:", error);
    },
  });
};

// Bulk create custom pricings
export const useBulkCreateCustomPricing = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: customPricingService.bulkCreateCustomPricing,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customPricings"] });
      queryClient.invalidateQueries({ queryKey: ["myCustomPricings"] });
    },
    onError: (error) => {
      console.error("Error bulk creating custom pricings:", error);
    },
  });
};
